import { Component, Input, Output, EventEmitter } from '@angular/core';
import {Location as NgCommonLocation} from '@angular/common';
import { Influencer } from '../../../../models/influencer';
import { InfluencerGroup } from '../../../../models/influencer-group';

@Component({
  selector: 'monthly-visited-breadcrumb',
  templateUrl: './monthly-visited-breadcrumb.component.html',
  styleUrls: ['./monthly-visited-breadcrumb.component.scss']
})
export class MonthlyVisitedBreadcrumbComponent {

  @Input()
  public influencerGroup: InfluencerGroup;
  @Input()
  public influencerList: Influencer[] = [];
  @Input()
  public totalInfluencer: number;
  @Output()
  public checkEvent = new EventEmitter<any>();

  public checkAll: boolean;

  constructor(private location: NgCommonLocation) { }

  onCheckSelectAll(event) {
    this.checkEvent.emit(this.checkAll);
  }

  backToPreviousPage() {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/group-details/monthly-visited-breadcrumb/monthly-visited-breadcrumb.component.ts